import { render, staticRenderFns } from "./InfoQR.vue?vue&type=template&id=8e581442"
import script from "./InfoQR.vue?vue&type=script&lang=js"
export * from "./InfoQR.vue?vue&type=script&lang=js"
import style0 from "./InfoQR.vue?vue&type=style&index=0&id=8e581442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QField,QImg});
